import {LoginState} from '../states/login-state';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {Deserialize} from 'cerialize';

export const LoginStateSelector = createSelector(createFeatureSelector(LoginState.key),
  (state: LoginState): LoginState => {
    return Deserialize(state, LoginState);
  });
